import styled from "styled-components";

export const ContentWrapper = styled.div`
    /* background-color    : #efefef; */
    background-image: linear-gradient(#cbebfa,#fff 10%);
    padding             : 8px;
`